/* eslint-disable */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import routes from '../../../routes';
import {
  EMPTY_STRING,
  LOCAL_STORE_AUTH_TOKEN,
  LOCAL_STORE_AUTH_USER,
  RESPONSIVE_CLASS_NAME
} from '../../../constants/constants';
import { Button, Navbar, Nav, NavDropdown } from 'react-bootstrap'
import './header.style.scss';


/**
 * Class representing the header component.
 * @extends Component
 * */
@inject('authenticationStore', 'filesStore')
@observer
class Header extends Component {

  static propTypes = {
    authenticationStore: PropTypes.shape({
      setUsername: PropTypes.func,
      setPassword: PropTypes.func,
    }),

    filesStore: PropTypes.shape({
      reset: PropTypes.func
    }),

    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
  };

  static defaultProps = {
    authenticationStore: {},
    filesStore: {}
  };

  state = {
    cssMobileResponsive: EMPTY_STRING,
  };

  headerRef = React.createRef();

  /**
   * Toggles the nav menu on mobile resolution.
   * */
  toggle = () => {
    const { cssMobileResponsive } = this.state;

    this.setState({
      cssMobileResponsive: (cssMobileResponsive === EMPTY_STRING ? RESPONSIVE_CLASS_NAME : EMPTY_STRING)
    });
  };

  /**
   * Reset mobile responsive state to empty.
   * */
  resetToggle = () => {
    this.setState({
      cssMobileResponsive: EMPTY_STRING
    });
  };

  /**
  * Clear authorization token and redirect to login
  * */
  logout = () => {
    const {
      authenticationStore: { setUsername, setPassword },
      filesStore: { reset },
      history: {
        push,
      }
    } = this.props;
    setUsername(null);
    setPassword(null);
    localStorage.removeItem(LOCAL_STORE_AUTH_USER);
    localStorage.removeItem(LOCAL_STORE_AUTH_TOKEN);
    reset();
    this.toggle();
    push(routes.authentication);
  };

  /**
  * Go to My Messages
  * */
  myMessages = () => {
    const {
      history: {
        push,
      }
    } = this.props;
    this.resetToggle();
    push(routes.dashboard);
  };

  /**
  * Go to help page
  * */
  help = () => {
    const {
      history: {
        push,
      }
    } = this.props;
    this.toggle();
    push(routes.help);
  };

  /**
  * Get user from local store
  * */
  getUserFromLocalStore = () => {
    const authorizationUserLocalStore = localStorage.getItem(LOCAL_STORE_AUTH_USER);
    return authorizationUserLocalStore ? JSON.parse(authorizationUserLocalStore) : null;
  };

  render() {
    const authorizationUser = this.getUserFromLocalStore();
    const { cssMobileResponsive } = this.state;
    return (
      <div ref={(node) => { this.headerRef = node; }} id="top-nav-elem" className={`top-nav container-fluid ${cssMobileResponsive}`}>
        <div className="container">
          <Navbar collapseOnSelect expand="sm" className="main-nav">
            <Navbar.Brand><img src="/prc-saltillo-logo.png" height="25"></img></Navbar.Brand>
            {authorizationUser && (
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            )}  
            {authorizationUser && (
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto">
                <Nav.Link onClick={this.myMessages} eventKey="1">My Messages</Nav.Link>
                <Nav.Link onClick={this.help}  eventKey="2">Help</Nav.Link>
              </Nav>
              <Nav >
                <Nav.Link onClick={this.logout} eventKey="3">Logout &nbsp;<FontAwesomeIcon icon={faSignOutAlt} /></Nav.Link>
              </Nav>
            </Navbar.Collapse>
            )}
          </Navbar>
        </div>
      </div>
    );
  }

}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/common/components/header/header.component.js